import Avatar, { AvatarProps } from '@mui/material/Avatar';
import { Theme } from '@mui/material/styles';
import React, { memo, useEffect, useState } from 'react';
import { IMAGE_PLACEHOLDER } from '../core/utils';

export interface ISmartAvatar extends AvatarProps {
  defaultImg?: string;
  size?: number;
}

function SmartAvatar(props: ISmartAvatar) {
  const {defaultImg, size, ...avatarProps} = {defaultImg: IMAGE_PLACEHOLDER, size: 11, ...props};
  const [img, setImg] = useState(props.src);

  useEffect(() => {
    setImg(props.src);
  }, [props.src]);

  const handleError = (event: any) => {
    if (props.onError) {
      props.onError(event);
    }
    setImg(defaultImg);
  };

  return (
    <Avatar
      {...avatarProps}
      src={img}
      onError={handleError}
      imgProps={{ ...(props.imgProps ? props.imgProps : {}), style: { objectPosition: 'top' } }}
      sx={{
        cursor: 'pointer',
        width: (theme: Theme) => theme.spacing(size),
        height: (theme: Theme) => theme.spacing(size),
        ...(props.sx ? props.sx : {})
      }}
    />
  );
}

export default memo(SmartAvatar);
